import { useState, } from "react";

const ModalLimiteVehiculo = ({ isOpen, onCancel, onConfirm, limiteActual }) => {

    const [formData, setFormData] = useState({
        limiteVehiculo: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            {isOpen && (
                <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                    <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
                    <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
                        <div className="py-4 text-left px-6">
                            <div className="mb-4">
                                <p className="text-xl">NUEVO LIMITE VEHICULOS</p>
                            </div>
                            <div className="mb-4">
                                <p className="text-md">Limite Actual: {limiteActual}</p>
                            </div>
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="limiteVehiculo">
                                    Nuevo Limite Vehiculo<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="limiteVehiculo"
                                    name="limiteVehiculo"
                                    value={formData.limiteVehiculo}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="LimiteVehiculo"
                                    min={1}
                                />
                            </div>
                            <div className="flex justify-end">
                                <button
                                    className="mr-4 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={onCancel}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={() => onConfirm(formData)}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ModalLimiteVehiculo;